import React from "react";
import styled from "styled-components";

const StyledContainer = styled.div<{ isSingleLogoOnly?: boolean }>`
  display: grid;
  grid-template-columns: ${({ isSingleLogoOnly }) => (isSingleLogoOnly ? "none" : "1fr 1fr")};
  grid-gap: ${({ isSingleLogoOnly }) => (isSingleLogoOnly ? "0px" : "8px")};
  width: 100%;

  .programSchoolLogo,
  .mcLogo {
    max-height: 128px;
    max-width: ${({ isSingleLogoOnly }) => (isSingleLogoOnly ? "none" : "210px")};
    margin-left: auto;
    margin-right: auto;
  }

  .logoImage {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

function ProgramSchoolLogoBlock({
  programLogo,
  programName,
  schoolLogo,
  schoolName,
}: {
  programLogo?: string;
  programName?: string;
  schoolLogo?: string;
  schoolName?: string;
}) {
  const MentorCollectiveLogo = (
    <div className="mcLogo">
      <img
        className="logoImage"
        src="/images/mc_logo_full.png"
        alt="Mentor Collective"
        aria-label="Mentor Collective logo"
      />
    </div>
  );

  const LogoBlock = () => {
    // MC Logo Only
    if (!programLogo && !schoolLogo) {
      return <StyledContainer isSingleLogoOnly={true}>{MentorCollectiveLogo}</StyledContainer>;
    }

    // MC Logo with Program or School Logo
    return (
      <StyledContainer>
        {MentorCollectiveLogo}
        <div className="programSchoolLogo">
          {programLogo ? (
            <img
              className="logoImage"
              src={programLogo}
              alt={programName}
              aria-label="Program logo"
            />
          ) : (
            <img className="logoImage" src={schoolLogo} alt={schoolName} aria-label="School logo" />
          )}
        </div>
      </StyledContainer>
    );
  };

  return <LogoBlock />;
}

export default ProgramSchoolLogoBlock;
